module.exports = __webpack_public_path__ + "static/media/under-construction.31418e6f.svg";